'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var ClickableChip_module = require('./ClickableChip.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ClickableChip = ({
  onClick,
  chipText,
  disabled
}) => {
  const onAction = () => {
    if (onClick && !disabled) onClick(chipText || '');
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: ClickableChip_module["default"].styledChipContainer,
    role: "button",
    onTouchEnd: e => {
      // this stops the mobile keyboard (at least on ios) from
      // automatically hiding itself after a message is sent.
      e.preventDefault();
      onAction();
    },
    onClick: onAction,
    onKeyDown: onAction,
    tabIndex: 0
  }, chipText);
};

exports["default"] = ClickableChip;
